export default "__VITE_ASSET__DwgXivQI__"